import { render, staticRenderFns } from "./ResultsByQuestionsThematic.vue?vue&type=template&id=fe4dafd0&"
import script from "./ResultsByQuestionsThematic.vue?vue&type=script&lang=js&"
export * from "./ResultsByQuestionsThematic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports